var addViewDialog = {
	addView: "Add View",
	editView: "Edit View",
	viewNameHelperText: {
		invalidViewNameLength: "View name length must be between {{minLength}} to {{maxLength}} characters long.",
		invalidViewName: "View name must contain atleast one alphabet and not include any special characters besides {{allowedSpecialCharacters}}",
		viewNameNotUnique: "View name is taken, try again with a different name."
	},
	viewName: "View Name",
	enterViewName: "Enter view name",
	dashboardCustomisation: "Dashboard Customisation",
	showAllQuestions: "Show All Questions",
	allQuestionsAreVisibleByDefault: "All questions are visible by default. Users can hide any questions that are not needed.",
	startFromBlank: "Start from blank",
	allQuestionsAreHiddenByDefault: "All questions are hidden by default. Users must unhide the questions they want to display.",
	spocsChartCustomisation: "SPoC Chart Customisation",
	allowSPoCToChangeGraphType: "Allow SPoC to Change Graph Type",
	spocCanSelectAnyAvailableGraphType: "SPoC can select any available graph type (e.g., Bar, Line, Pie, Area).",
	restrictToSelectType: "Restrict to Select Type",
	spocCannotChangeTheGraphType: "SPoC cannot change the graph type set by the BOU.",
	errorMessages: {
		unexpectedError: "There was an unexpected error while trying to add the view, please try again.",
		maximumViewCountExceededErrorText: "A new view could not be created, as the maximum limit of {{maximumSurveyViewCount}} views per survey has been reached.",
		noSurveyLinkFoundErrorText: "No survey links created yet."
	}
};
var master = "Master";
var mean = "Mean";
var lazyLoadingText = "Loading more data, please wait.";
var noViewsFound = "No views found.";
var views = {
	detractors: "Detractors ({{startRange}} - {{endRange}})",
	promoters: "Promoters ({{startRange}} - {{endRange}})",
	passives: "Passives ({{startRange}} - {{endRange}})",
	answers: "Answers",
	count: "Count",
	percentage: "Percentage",
	total: "Total",
	type: "Type",
	sample: "Sample: {{sample}}",
	skipped: "Skipped: {{skipped}}",
	viewsStringLiteral: "Views"
};
var topNWords = "Top {{n}} Words";
var downloadPDF = "Download PDF";
var noDataFound = "No data found.";
var manageFilters = "Manage Filters";
var enTranslationSurveyDashboard = {
	addViewDialog: addViewDialog,
	master: master,
	mean: mean,
	lazyLoadingText: lazyLoadingText,
	noViewsFound: noViewsFound,
	views: views,
	topNWords: topNWords,
	downloadPDF: downloadPDF,
	noDataFound: noDataFound,
	manageFilters: manageFilters
};

var value = "Value";
var valuePlaceholder = "Enter value";
var addFilter = "Add Filter";
var noFiltersAppliedText = "No filters applied.";
var filtersAppliedText = "{{numberOfFilters}} filters applied.";
var maxLimitReachedText = "Max. Limit Reached";
var maxFiltersAppliedText = "A maximum of {{maxFilterLimit}} filters can be applied.";
var selectValueTypeText = "Select value type";
var valueType = "Value Type";
var filterAlreadyAddedText = "Filter for this value type has already been added, please choose a different type.";
var removeAllFilters = "Remove All Filters";
var applyFilters = "Apply Filters";
var removeAllFiltersDialogDescription = "Are you sure you want to remove all the filters?";
var createdAt = "Created At";
var modifiedOn = "Modified On";
var fromDateLabelText = "From Date";
var toDateLabelText = "To Date";
var enTranslationFilters = {
	value: value,
	valuePlaceholder: valuePlaceholder,
	addFilter: addFilter,
	noFiltersAppliedText: noFiltersAppliedText,
	filtersAppliedText: filtersAppliedText,
	maxLimitReachedText: maxLimitReachedText,
	maxFiltersAppliedText: maxFiltersAppliedText,
	selectValueTypeText: selectValueTypeText,
	valueType: valueType,
	filterAlreadyAddedText: filterAlreadyAddedText,
	removeAllFilters: removeAllFilters,
	applyFilters: applyFilters,
	removeAllFiltersDialogDescription: removeAllFiltersDialogDescription,
	createdAt: createdAt,
	modifiedOn: modifiedOn,
	fromDateLabelText: fromDateLabelText,
	toDateLabelText: toDateLabelText
};

var manageBOUTitle = "Manage BOU";
var role = "Role";
var rolePlaceholder = "Select role";
var addNewBOUDialog = {
	addNewBOU: "Add New BOU",
	addBOU: "Add BOU",
	fetchingRolesText: "Fetching list of roles, please hold on.",
	errorTexts: {
		unexpectedError: "There was an unexpected error while trying to add the BOU, please try again.",
		userAlreadyExists: "The BOU already exists. Please try again with a different email address.",
		spocCannotBeBOU: "The user already exists as a SPoC. Please try again with a different email address."
	}
};
var editBOUserDialog = {
	editBOU: "Edit User",
	errorTexts: {
		unexpectedError: "There was an unexpected error while trying to save the changes, please try again."
	}
};
var sendPasswordResetDialog = {
	sendAuthenticationEmail: "Send Authentication Email",
	sendResetLink: "Send Reset Link",
	dialogDescription: "Are you sure you want to send the password reset link via email to the selected user?",
	errorTexts: {
		unexpectedError: "There was an unexpected error while trying to send authentication email, please try again."
	},
	successMessage: "Authentication email has been sent to the user successfully."
};
var archiveBOUserDialog = {
	startDescriptionText: "Are you sure you want to archive",
	endDescriptionText: "? Once Archived, the user will no longer have access to the platform.",
	archiveUser: "Archive User",
	errorTexts: {
		unexpectedError: "There was an unexpected error while trying to archive the user, please try again.",
		cannotArchiveSelf: "This action is invalid as the user cannot archive themself."
	}
};
var enTranslationManageUsers = {
	manageBOUTitle: manageBOUTitle,
	role: role,
	rolePlaceholder: rolePlaceholder,
	addNewBOUDialog: addNewBOUDialog,
	editBOUserDialog: editBOUserDialog,
	sendPasswordResetDialog: sendPasswordResetDialog,
	archiveBOUserDialog: archiveBOUserDialog
};

var inProgress = "In Progress";
var lastPage = "Last Page";
var notStarted = "Not Started";
var unassigned = "Unassigned";
var submitted = "Submitted";
var started = "Started";
var viewed = "Viewed";
var assigning = "Assigning...";
var enTranslationSurveyLinkStatus = {
	inProgress: inProgress,
	lastPage: lastPage,
	notStarted: notStarted,
	unassigned: unassigned,
	submitted: submitted,
	started: started,
	viewed: viewed,
	assigning: assigning
};

var surveyRespondentInternalServerErrorTitle = "Oops, Something Went Wrong";
var surveyRespondentInternalServerErrorDescription = "Don't worry! Your responses are safe. We encountered an issue, but your data remains secure. Please go back to the previous page and try again later. Thank you for your patience.";
var surveyRespondentPageNotFoundTitle = "Oops, Page Not Found";
var surveyRespondentPageNotFoundDescription = "It seems like this survey doesn’t belong to you, please check the link being used once and try again. Thank you for your patience.";
var surveyRespondentTimeOutTitle = "Oops, Request Timed Out";
var surveyRespondentTimeOutDescription = "Don't worry! Your responses are safe. We encountered an issue, but your data remains secure. Please go back to the previous page and try again later. Thank you for your patience.";
var surveyClosedTitle = "Oops, Survey is Closed";
var surveyClosedDescription = "It seems like this survey is currently closed. Your participation is appreciated. Please contact the survey administrator for further assistance. Thank you for your understanding.";
var backToPreviousPageLabel = "Back to Previous Page";
var enTranslationSurveyRespondentErrors = {
	surveyRespondentInternalServerErrorTitle: surveyRespondentInternalServerErrorTitle,
	surveyRespondentInternalServerErrorDescription: surveyRespondentInternalServerErrorDescription,
	surveyRespondentPageNotFoundTitle: surveyRespondentPageNotFoundTitle,
	surveyRespondentPageNotFoundDescription: surveyRespondentPageNotFoundDescription,
	surveyRespondentTimeOutTitle: surveyRespondentTimeOutTitle,
	surveyRespondentTimeOutDescription: surveyRespondentTimeOutDescription,
	surveyClosedTitle: surveyClosedTitle,
	surveyClosedDescription: surveyClosedDescription,
	backToPreviousPageLabel: backToPreviousPageLabel
};

var privacyPolicy = "Privacy Policy";
var needAssistance = "Need Assistance?";
var letsTalk = "Let's Talk";
var startSurveyConsentDialog = {
	title: "Consent for Participation",
	iConsentToParticipate: "I consent to participate in this survey."
};
var enTranslationWelcomePage = {
	privacyPolicy: privacyPolicy,
	needAssistance: needAssistance,
	letsTalk: letsTalk,
	startSurveyConsentDialog: startSurveyConsentDialog
};

var draft = "Draft";
var active = "Active";
var closed = "Closed";
var enTranslationSurveyStatus = {
	draft: draft,
	active: active,
	closed: closed
};

var projects = "Projects";
var createNewProject = "Create New Project";
var goToProjectButtonText = "Go To Project";
var selectProjectDropdownPlaceholder = "Select Project";
var activeProjectsTitle = "Active Projects";
var archivedProjectsTitle = "Archived Projects";
var noProjectsFoundTitle = "No Projects Found";
var noProjectsFoundDescription = "No projects found. Get started by creating a new project.";
var fetchingProjectsErrorText = "There was an unexpected error while trying to fetch the list of projects, please refresh and try again.";
var projectNameNotUniqueErrorText = "The project name is taken, try again with a different name.";
var invalidProjectNameErrorText = "The project name must contain atleast one alphabet and not include any special characters besides {{allowedSpecialCharacters}}";
var invalidProjectNameLengthErrorText = "The project name length must be between {{minLength}} to {{maxLength}} characters long.";
var invalidProjectDatesErrorText = "The project dates are invalid, try again with different dates.";
var archiveProjectTitle = "Archive Project";
var enterProjectNamePlaceholder = "Enter project name";
var startDateLabel = "Start Date";
var endDateLabel = "End Date";
var projectNameLabel = "Project Name";
var projectListHeaders = {
	project: "Project",
	creator: "Creator",
	surveys: "Surveys",
	createdOn: "Created On",
	lastModified: "Last Modified"
};
var settings$1 = {
	settingsTitle: "Settings",
	updateProjectDetails: {
		startAndEndDateTitle: "Start Date & End Date",
		startAndEndDateDescription: "These dates are for representation purposes and do not reflect the actual project start and end dates.",
		archiveProjectDescription: "Please be aware that once archived, the project can’t be unarchived again.",
		unexpectedErrorText: "There was an unexpected error while trying to save changes to the project, please try again."
	}
};
var createNewProjectDialog = {
	infoText: "Please provide the project name, this will be used as the project’s display name. You can change this later on in the project settings.",
	createProjectButtonText: "Create Project",
	unexpectedErrorText: "There was an unexpected error while trying to create the project, please try again."
};
var cloneProjectDialog = {
	startInfoText: "Would you like to create a clone of",
	endInfoText: "project?",
	cloneProject: "Clone Project",
	unexpectedErrorText: "There was an unexpected error while trying to clone the project, please try again.",
	cloneProjectSuffix: "- clone"
};
var archiveProjectDialog = {
	areYouSureText: "Are you sure you want to archive the selected project",
	archiveInfoText: "? Please be aware that once archived, the project can’t be unarchived again.",
	projectNamePlaceholder: "{{projectName}}",
	archiveProjectNote: "*Please note: All the active surveys will be closed on archival of the project.",
	confirmArchiveText: "Please enter the project name below to confirm archiving.",
	incorrectProjectNameErrorLabel: "Incorrect project name, please try again.",
	unexpectedErrorText: "There was an unexpected error while trying to archive the project, please try again.",
	projectAlreadyArchivedErrorText: "This action is invalid as the project has already been archived."
};
var respondentList = {
	live: "Live",
	test: "Test",
	uploadCSV: "Upload CSV",
	deleteColumn: "Delete Column",
	downloadCSV: "Download CSV",
	reUploadCSV: "Re-Upload CSV",
	deletedColumnFilterErrorTitle: "Column Filter Deleted",
	deletedColumnFilterDescription: "The selected column filter has deleted column(s), please click on the refresh button and try again.",
	columnNames: {
		id: "ID",
		firstName: "First Name",
		lastName: "Last Name",
		emailAddress: "Email Address",
		phoneNumber: "Phone Number",
		survey: "Survey",
		surveyStatus: "Survey Status"
	},
	noRespondentsAddedTitle: "No Respondents Found",
	noRespondentsAddedDescription: "No respondents have been added. Begin by uploading a CSV of respondents.",
	noSurveyRespondentsAreAssignedTitle: "No Respondents Assigned",
	inProgressDescription: "The respondent data is currently being processed. Please wait for a moment, and the updated information will be displayed once the processing is complete.",
	errorFetchingRespondents: "There was an unexpected error while trying to fetch the respondents, please try again.",
	backToProjects: "Back to Projects",
	deletedColumnFilterError: "A filter has been applied on a column which is now deleted, please try again.",
	downloadTemplateDescription: "Ensure that your CSV follows the template's column structure to avoid errors. Use the pre-defined template for the correct structure, as other files may not be compatible.",
	downloadTemplate: "Download Template",
	uploadRespondentCSVTitle: "Upload Respondent CSV",
	dragAndDrop: "Drag and drop to upload or",
	browse: "Browse",
	fileFormatCSV: "File Format: CSV",
	validatingFile: "Validating file, please wait.",
	fileDetails: "File Details",
	respondentUpdateProgressDescription: "Respondent update in progress.",
	projectArchivedDescription: "The project has been archived.",
	duplicateValidationTitle: "Duplicate Validation",
	chooseUniqueColumnTitle: "Choose Unique Column",
	chooseUniqueColumnDescription: "Choose a unique CSV column to check for duplicates in your file.",
	selectUniqueColumn: "Select unique column",
	validate: "Validate",
	checkingForDuplicates: "Checking for duplicates in",
	pleaseWait: ", please wait.",
	ignoreAndProceed: "Ignore and proceed",
	fileUploadedSuccessfullyDescription: "The respondent upload process has been initiated. The data will be updated shortly.",
	invalidFileErrorDescription: "The uploaded file is invalid, please rectify and try again.",
	invalidUniqueColumnErrorDescription: "The unique column selected is invalid, please rectify and try again.",
	columnLimitReachedErrorDescription: "Column limit has been reached for the CSV file, please rectify and try again.",
	duplicateRecordsDetected: "Duplicate records have been detected in the chosen unique column. Kindly review and rectify them for data accuracy, or proceed without changes, bearing in mind that this may impact the results.",
	editRespondentDetailsDialog: {
		title: "Edit Respondent",
		surveyStatusLabel: "Survey Status",
		secondaryButtonText: "Cancel",
		inputFieldHelperText: "{{label}} cannot be more than {{maxInputLength}} characters.",
		successDialogText: "The respondent details have been saved successfully.",
		primaryButtonText: "Save Changes",
		selectSurvey: "Select survey",
		selectSPoCs: "Select SPoC(s)",
		noSPoCFound: "No SPoC found",
		spoc: "SPoC",
		errorMessages: {
			projectArchivedDescription: "The project has been archived, no further modifications can be made.",
			genericErrorDialogText: "There was an unexpected error while trying to save the changes, please try again.",
			noSurveyQuestionsPresentErrorText: "This survey does not contain any questions, please add questions before assigning the survey.",
			surveyIsClosed: "The survey has been closed, no further modifications can be made.",
			surveyAlreadySubmittedErrorBannerText: "The assigned survey cannot be changed, as the respondent has already submitted the survey.",
			assignmentInProgressErrorBannerText: "The survey cannot be changed, as the survey assignment is in progress.",
			maximumSPoCLimitReached: "The respondent cannot be assigned to more than {{maxRespondentSPoC}} SPoCs."
		}
	}
};
var unassignRespondents = {
	unassignSurveyRespondentDialogTitle: "Unassign Respondents?",
	areYouSureText: "Are you sure you want to unassign",
	unassignSingleSurveyRespondentDialogText: "from this survey? The respective respondent will not be deleted, but once unassigned, the survey link will become invalid.",
	unassignBulkSurveyRespondentDialogText: "respondents from this survey?  The respective respondents will not be deleted, but once unassigned, the survey link will become invalid.",
	unassign: "Unassign ({{primaryButtonCountdown}})",
	unassignRespondentGenericErrorDialogText: "There was an unexpected error while trying to unassign the respondent(s), please try again.",
	projectAlreadyArchivedUnassignRespondentError: "This project has been archived, the respondent(s) cannot be unassigned from this survey.",
	respondentsAlreadyUnassigned: "The selected respondents have already been unassigned.",
	surveyAlreadySubmittedErrorMessage: "The survey cannot be unassigned, as the respondent has already submitted the survey.",
	unassignSurveyDialogNote: "*Please note: The respondent(s) cannot be unassigned if they have already submitted the survey.",
	successDescription: "The respondent(s) have been unassigned successfully."
};
var reOpenSurveyLink = {
	reOpenLinks: "Re-Open Links",
	projectAlreadyArchivedErrorMessage: "This action is invalid as the project is already archived.",
	surveyClosedErrorMessage: "This action is invalid as the survey is currently closed.",
	unexpectedErrorMessage: "There was an unexpected error while trying to re-open the links, please try again.",
	successMessage: "The links were re-opened successfully.",
	dialogDescription: "Are you sure you want to re-open the links? This action will allow users to resubmit their survey."
};
var reports = {
	reports: "Reports",
	downloadReports: "Download Reports",
	linkTypeText: "Link Type",
	reportTypeText: "Report Type",
	chooseSurveyText: "Choose Survey",
	selectSurveyText: "Select survey",
	chooseSurveyDescriptionText: "Please select the survey for which you would like to download the report.",
	downloadPreferencesText: "Download Preferences",
	downloadPreferencesDescriptionText: "Please select the link type and report type.",
	downloadReportsSuccessText: "Your request to download the report has been received. Please note that it may take some time to process the report. Once the processing is complete, the requested report's download link will be sent to your email.",
	downloadReportsErrorText: "There was an unexpected error while trying to download the reports, please try again.",
	noSurveyAnswerOrLinkFound: "No survey answer or link found, the report cannot be generated.",
	surveyIsInDraftState: "The selected survey is in the draft state, the report cannot be generated.",
	noSurveyCreatedText: "No survey has been created yet. Please note that a report can be generated for an existing survey only.",
	downloadPreferencesEnumOptions: {
		coded: "Coded",
		nonCoded: "Non-Coded",
		live: "Live Links",
		test: "Test Links"
	},
	embeds: {
		addNewEmbed: "Add New Embed",
		addEmbedButtonText: "Add Embed",
		enterEmbedName: "Enter embed name",
		enterEmbedCode: "Enter embed code",
		embedName: "Embed Name",
		embedCode: "Embed Code",
		addedOn: "Added On",
		embedSection: {
			embeddedReports: "Embedded Reports",
			showMore: "Show More",
			showLess: "Show Less",
			noEmbedsAdded: "No embeds added."
		},
		embedView: {
			viewReportButtonText: "View Report",
			noReportSelected: "No Report Selected",
			invalidReportFound: "Invalid Report Found",
			selectReportPlaceholder: "Select report"
		},
		deleteEmbed: {
			dialogTitleText: "Delete Embed",
			dialogDescription: "Are you sure you want to delete this embed? Please note that once deleted, the embed cannot be viewed.",
			dialogErrorText: "There was an unexpected error while trying to delete the embed, please try again."
		},
		assignToSelectedSPoCs: "Assign to selected SPoC(s)",
		searchAndAddSPoCsDialogDescription: "Search and add SPoC(s) to the embed link.",
		addEmbedSuccessText: "The embed link has been added successfully.",
		dialogErrorText: "There was an unexpected error while trying to add the embed link, please try again.",
		embedNameHelperText: {
			invalidEmbedNameLength: "Embed name length must be between {{minLength}} to {{maxLength}} characters long.",
			invalidEmbedName: "Embed name must contain atleast one alphabet and not include any special characters besides {{allowedSpecialCharacters}}",
			invalidEmbedCodeLength: "Embed code length must be between {{minLength}} to {{maxLength}} characters long.",
			invalidIframe: "Please enter a valid iFrame."
		},
		embedNameNotUniqueErrorText: "The embed name is taken, try again with a different name.",
		maximumEmbedCountExceededErrorText: "A new embed link could not be created, as the maximum limit of {{maxEmbedCount}} embed links per project has been reached."
	}
};
var assignToSurvey = {
	assignToSurvey: "Assign to Survey",
	chooseSurveyDialogTitle: "Choose Survey",
	dialogPrimaryButtonText: "Assign Survey",
	respondentCount: "{{respondentCount}}",
	surveyName: "{{surveyName}}",
	dialogSuccessText: "respondent(s) were requested to be assigned to the",
	successfullyText: ". The data will be updated shortly.",
	dialogErrorText: "There was an unexpected error while trying to assign the survey to the selected respondents, please try again.",
	respondentAlreadyAssignedTitleText: "Respondents Already Assigned",
	respondentAlreadyAssignedWarningText: "Verify that the selected respondents are not currently assigned to any other survey. Please unassign them from any existing surveys before proceeding to assign them to the new survey.",
	respondentsSelected: "Respondents Selected",
	respondentsAssigned: "Respondents Assigned",
	respondentsNotAssigned: "Respondents Not Assigned",
	projectArchivedErrorText: "This project has been archived, a survey cannot be assigned to the selected respondent(s).",
	surveyIsClosedErrorText: "This survey is closed, a survey cannot be assigned to the selected respondent(s).",
	respondentAssignmentInProgressTitleText: "Respondent Assignment in Progress",
	respondentAssignmentInProgressWarningText: "Verify that the selected respondent(s) are not currently being assigned to any other survey.",
	noSurveyCreatedText: "No survey has been created yet. Please note that respondent(s) can be assigned to an existing survey only.",
	noSurveyQuestionsPresentErrorText: "This survey does not contain any questions, please add questions before assigning the survey."
};
var deleteRespondentColumn = {
	theColumn: "The column",
	deletedColumnName: "{{deletedColumnName}}",
	hasBeenDeletedSuccessfully: "has been deleted successfully.",
	deleteRespondentColumnErrorText: "There was an unexpected error while trying to delete the column, please try again.",
	projectUniqueColumnCannotBeDeletedErrorText: "The selected column is unique to the project and cannot be deleted.",
	projectArchivedErrorText: "This project has been archived, the column cannot be deleted.",
	dialogPlaceholderText: "Select Column",
	dialogLabelText: "Column",
	dialogWarningText: "This action will lead to the deletion of the column, causing the loss of data present in the respective column."
};
var downloadRespondentCSV = {
	dialogDescriptionText: "Are you sure you want to download the respondents CSV?",
	downloadSuccessText: "The respondents CSV has been downloaded successfully.",
	downloadErrorText: "There was an unexpected error while trying to download the respondents CSV, please try again."
};
var dashboard = {
	dashboardTabTitle: "Dashboard",
	noDataTitle: "No Data Available",
	noSurveyResultsDescription: "The survey results will appear here once the data is available. Start collecting responses to see meaningful insights.",
	noSurveyBreakdownDescription: "The survey breakdown will appear here once data is available. Start collecting responses to see meaningful insights.",
	surveyResultsTitle: "Survey Results",
	invitationsText: "Invitations",
	surveyBreakdownText: "SURVEY BREAKDOWN",
	typeText: "Type",
	volumeText: "Volume",
	submissionDataTitle: "Submission Data",
	dailySubmissionsText: "Daily Submissions",
	totalSubmissionsText: "Total Submissions",
	bothText: "Both",
	lastDataSetsText: "(Last {{days}} data sets)",
	errorFetchingDataText: "There was an unexpected error while trying to fetch the data, please try again.",
	viewResultsButtonText: "View Results",
	allSurveysText: "All Surveys",
	pivotTable: {
		pivotTableTitle: "Pivot Table",
		dropdownPlaceHolder: "Select an option",
		emptyStateText: "No option selected.",
		somethingWentWrongErrorDescription: "Something went wrong while trying to fetch the pivot data, please try again.",
		columnHeaders: {
			total: "Total",
			submissionRate: "Submission Rate"
		}
	}
};
var userAccess = {
	userAccessTitle: "User Access",
	addSPoCButtontext: "Add SPoC",
	addBOUButtonText: "Add BOU",
	manageBOU: "Manage BOU",
	manageSPoCs: "Manage SPoCs",
	noSPoCFound: "No SPoC Found",
	noBOUserFound: "No BO User Found",
	manageSPoCsTableHeaders: {
		name: "Name",
		emailAddress: "Email Address",
		addedOn: "Added On",
		expiryDate: "Expiry Date"
	},
	manageBOUsersTableHeaders: {
		name: "Name",
		emailAddress: "Email Address",
		role: "Role",
		addedOn: "Added On",
		firstName: "First Name",
		lastName: "Last Name"
	},
	addNewSPoC: {
		addNewSPoCDialogTitle: "Add New SPoC",
		addSPoC: "Add SPoC",
		expiryDateLabel: "Expiry Date",
		expiryDatePlaceholder: "Enter expiry date",
		expiryDateHelperText: "Please select an expiry date.",
		projectAlreadyArchivedErrorDescription: "A new SPoC could not be added, as the project has been archived.",
		maxSPoCsReachedErrorDescription: "The maximum number of questions for the survey has been reached, no further questions can be added.",
		spocNotUniqueErrorDescription: "SPoC already exists, try again with a different email address.",
		invalidDateErrorHelperText: "Provided date is invalid, please enter a valid date",
		invalidExpiryDateErrorHelperText: "The expiry date must not be in past or should not more than 3 years from the time the project expires.",
		spocAddedSuccessfullyDescription: "The SPoC has been added successfully. Authentication mail has been sent to the SPoC.",
		unexpectedErrorWhileAddingSPoC: "There was an unexpected error while trying to add a new SPoC, please try again.",
		bouCannotBeSPoC: "This user already exists as BO user and hence, cannot be added as a SPoC."
	},
	addProjectBOUser: {
		addProjectBOUserDialogTitle: "Add User(s)",
		addProjectBOUserDialogDescription: "Search and add user(s) to the project.",
		searchUsersPlaceholderText: "Search users",
		selectedUsers: "Selected User(s)",
		noUserSelected: "No user selected.",
		addButtonText: "Add",
		noUserFoundText: "No user found",
		fetchingBOUsersText: "Fetching list of user(s), please hold on.",
		fetchingBOUsersErrorText: "There was an unexpected error while trying to fetch the list of user(s), please try again.",
		addBOUserToProjectSuccessText: "The user(s) have been added to the project successfully.",
		addBOUserToProjectErrorText: "There was an unexpected error while trying to add the user(s) to the project, please try again.",
		maxUsersReachedErrorDescription: "The maximum number of users for the project has been reached, no further users can be added.",
		boUserAlreadyExistsErrorDescription: "A selected user was already added to the project, please try again."
	},
	removeProjectBOUser: {
		removeUserWithquestionMark: "Remove User(s)?",
		areYouSureYouWantToRemove: "Are you sure you want to remove",
		removeUserDescription: "from this project? Once removed, these users will no longer have access to the project.",
		remove: "Remove ({{primaryButtonCountdown}})",
		removeMultipleUsersDescription: "user(s) from this project? Once removed, these user(s) will no longer have access to the project.",
		removeUserNote: "*Please note: The creator of the project/ current user will not be removed, if they were selected.",
		unexpectedErrorDescription: "There was an unexpected error while trying to remove the user(s) from the project, please try again.",
		removeBOUserFromProjectSuccessText: "The user(s) have been removed from the project successfully."
	}
};
var spocRespondent = {
	tabs: {
		respondent: "Respondent",
		settings: "Settings"
	},
	settings: {
		name: "Name",
		passwordControl: "Password Control",
		removeSPoC: "Remove SPoC",
		removeSPoCWithQuestionMark: "Remove SPoC?",
		areYouSureYouWantToRemove: "Are you sure you want to remove",
		onceRemovedDescription: "? Once removed, the SPoC will no longer have access to the project.",
		resetPassword: "Reset Password",
		changePassword: "Change Password",
		newPasswordLabel: "New Password",
		newPasswordPlaceholder: "Enter new password",
		confirmNewPasswordLabel: "Confirm New Password",
		confirmNewPasswordPlaceholder: "Re-enter new password",
		thePasswordMust: "The password must:",
		mustBe8CharLong: "be at least 8 characters in length.",
		includeAtleast: "include at least 1 capital letter, 1 small letter, 1 special character.",
		passwordsDoNotMatch: "The entered passwords don't match, please check and try again.",
		passwordDoesNotFollowGuidelined: "The entered password does not follow the mentioned guidelines.",
		projectAlreadyArchivedErrorText: "This project has been archived, the SPoC password cannot be changed.",
		unexpectedErrorWhileChangingPassword: "There was an unexpected error while trying to change the password, please try again.",
		passwordChangedSuccessfully: "The password has been changed successfully.",
		changesSavedSuccessfullyDescription: "The changes have been saved successfully.",
		authEmailSent: "Authentication email for password reset has been sent to the SPoC successfully.",
		unexpectedErrorWhileRemovingSPoc: "There was an unexpected error while trying to remove the SPoC, please try again.",
		respondentAssignedToSPoC: "Please ensure that the selected SPoC(s) do not have any respondent(s) assigned to them."
	},
	somethingWentWrongErrorTitle: "Something Went Wrong",
	somethingWentWrongErrorDescription: "Something went wrong while trying to fetch the respondents, please refresh the page.",
	removeRespondentWithQuestionMark: "Remove Respondent?",
	areYouSureYouWantToRemove: "Are you sure you want to remove",
	spocsFromThisProject: "SPoC(s) from this project? You can add the SPoC(s) back later if needed.",
	removeRespondentDescription: "from this SPoC view? You can add the respondent back later if needed.",
	remove: "Remove",
	removeMultipleRespondentsDescription: "respondents from this SPoC view? You can add the respondents back later if needed.",
	unexpectedErrorWhileRemovingRepondentFromSPoc: "There was an unexpected error while trying to unassign respondent(s) from a SPoC, please try again."
};
var commonTexts = {
	fetchingSurveysText: "Fetching list of surveys, please hold on.",
	fetchingSurveysErrorText: "There was an unexpected error while trying to fetch the list of surveys, please try again.",
	fetchingSpocsText: "Fetching list of SPoC(s), please hold on.",
	fetchingSpocsErrorText: "There was an unexpected error while trying to fetch the list of SPoC(s), please try again."
};
var surveyDetails = {
	creatorText: "Creator:",
	creatorName: "{{creatorName}}",
	totalLinksText: "Total Links",
	viewSurveyTitle: "View Survey",
	unexpectedErrorText: "There was an unexpected error while trying to fetch the list of surveys, please try again.",
	cloneSurvey: {
		title: "Clone Survey",
		wouldYouLikeText: "Would you like to create a clone of",
		cloneSurveyInfoText: "survey? Upon cloning, please note that only the questionnaire, rules, and translations are cloned into the new survey.",
		unexpectedErrorDescription: "There was an unexpected error while trying to clone the survey, please try again.",
		projectArchivedErrorText: "The survey cannot be cloned as the project has already been archived.",
		maxSurveyLimitReachedErrorText: "The maximum survey limit of {{surveyLimit}} has been reached.",
		cloneSurveySuffix: "- Clone"
	}
};
var deleteRespondents = {
	dialogTitleText: "Delete Respondent?",
	dialogWarningStartText: "Are you sure you want to delete",
	dialogWarningEndTextSingular: "from this project? Once removed, the respondent will no longer have access to the survey and will no longer be a part of this project.",
	dialogWarningEndTextPlural: "respondents from this project?  Once removed, the respondents will no longer have access to the survey and will no longer be a part of this project.",
	"delete": "Delete ({{primaryButtonCountdown}})",
	deleteRespondentGenericErrorText: "There was an unexpected error while trying to delete the respondent(s), please try again.",
	projectAlreadyArchivedErrorText: "This project has been archived, the respondent(s) cannot be deleted from this project.",
	deleteRespondentNote: "*Please note: The respondent(s) cannot be deleted if they have already submitted the survey."
};
var assignSpocsToRespondents = {
	assignToSpocButtonText: "Assign to SPoC",
	dialogTitleText: "Choose SPoC(s)",
	searchSpocsPlaceholderText: "Search SPoC(s)",
	selectedSpocsTitleText: "Selected SPoC(s)",
	noSpocSelectedText: "No SPoC selected.",
	assignSpocsPrimaryButtonText: "Assign SPoC(s)",
	spocAssignSuccessDescription: "respondent(s) were requested to be assigned to the SPoC. The data will be updated shortly.",
	unexpectedErrorDescription: "There was an unexpected error while trying to assign the SPoC(s) to the selected respondent(s), please try again.",
	projectAlreadyArchivedText: "Respondent(s) could not be assigned, as the project has been archived.",
	maximumRespondentSpocLimitText: "Respondent(s) could not be assigned, as the maximum limit of {{numberOfSpocs}} SPoCs on the respondent(s) has been reached, please check your respondent(s) selection and try again.",
	noSpocsFoundText: "There were no SPoCs found for this project."
};
var viewSpocs = {
	dialogTitleText: "View SPoC(s)",
	embedText: "Embed Name:",
	respondentText: "Respondent:",
	noEmbedSpocsAssignedText: "This embed does not have any SPoC(s) assigned to it.",
	noRespondentSpocsAssignedText: "This user does not have any SPoC(s) assigned to them.",
	noSpocsFoundText: "No SPoC Found."
};
var enTranslationProjects = {
	projects: projects,
	createNewProject: createNewProject,
	goToProjectButtonText: goToProjectButtonText,
	selectProjectDropdownPlaceholder: selectProjectDropdownPlaceholder,
	activeProjectsTitle: activeProjectsTitle,
	archivedProjectsTitle: archivedProjectsTitle,
	noProjectsFoundTitle: noProjectsFoundTitle,
	noProjectsFoundDescription: noProjectsFoundDescription,
	fetchingProjectsErrorText: fetchingProjectsErrorText,
	projectNameNotUniqueErrorText: projectNameNotUniqueErrorText,
	invalidProjectNameErrorText: invalidProjectNameErrorText,
	invalidProjectNameLengthErrorText: invalidProjectNameLengthErrorText,
	invalidProjectDatesErrorText: invalidProjectDatesErrorText,
	archiveProjectTitle: archiveProjectTitle,
	enterProjectNamePlaceholder: enterProjectNamePlaceholder,
	startDateLabel: startDateLabel,
	endDateLabel: endDateLabel,
	projectNameLabel: projectNameLabel,
	projectListHeaders: projectListHeaders,
	settings: settings$1,
	createNewProjectDialog: createNewProjectDialog,
	cloneProjectDialog: cloneProjectDialog,
	archiveProjectDialog: archiveProjectDialog,
	respondentList: respondentList,
	unassignRespondents: unassignRespondents,
	reOpenSurveyLink: reOpenSurveyLink,
	reports: reports,
	assignToSurvey: assignToSurvey,
	deleteRespondentColumn: deleteRespondentColumn,
	downloadRespondentCSV: downloadRespondentCSV,
	dashboard: dashboard,
	userAccess: userAccess,
	spocRespondent: spocRespondent,
	commonTexts: commonTexts,
	surveyDetails: surveyDetails,
	deleteRespondents: deleteRespondents,
	assignSpocsToRespondents: assignSpocsToRespondents,
	viewSpocs: viewSpocs
};

var profileSettings = {
	name: "Name",
	profileSettingsTitle: "Profile Settings",
	genericErrorDialogText: "There was an unexpected error while trying to save the changes, please try again.",
	genericResetPasswordErrorDialogText: "There was an unexpected error while trying to send the authentication email, please try again.",
	resetPassword: "Reset Password",
	failedToSendEmail: "Failed to Send Email",
	resetUserPasswordDialog: {
		sendAuthenticationEmail: "Send Authentication Email",
		sendResetLink: "Send Reset Link",
		dialogDescription: "Would you like to send an authentication email for password reset to your registered email address?",
		unexpectedErrorText: "There was an unexpected error while trying to send authentication email, please try again.",
		emailSentSuccessfully: "Email Sent Successfully",
		successText: "Your request has been received, and an authentication email will be sent to you shortly for further instructions."
	}
};
var manageUsers = "Manage Users";
var auditLogs = {
	title: "Audit Logs",
	noAuditLogsFoundTitle: "No Audit Logs Found",
	fetchAuditLogsUnexpectedError: "There was an unexpected error while trying to fetch the audit logs, please try again.",
	emailAddressFilterLabel: "Email Address",
	eventNameFilterLabel: "Event Name",
	dateRangeFilterLabel: "Date Range"
};
var signOut = "Sign Out";
var featureInDevelopment = "This feature is still under development.";
var searchTableLoadingState = "Loading, please wait.";
var detailsLoadingState = "Loading details, please wait.";
var paginationIndicationText = "Showing {{startItem}}-{{endItem}} of {{totalItems}}";
var refresh = "Refresh";
var hyphen = "-";
var underscore = "_";
var goToHome = "Go to Home";
var proceed = "Proceed";
var cancel = "Cancel";
var done = "Done";
var close = "Close";
var back = "Back";
var remove = "Remove";
var unassign = "Unassign";
var download = "Download";
var dismiss = "Dismiss";
var uploadDialog = {
	fileUploaded: "File uploaded successfully.",
	columnLimitExceededDescription: "Column limit exceeded.",
	invalidFileNameDescription: "Invalid file name.",
	unexpectedErrorDescription: "Unexpected error occurred.",
	invalidFileFormatDescription: "Invalid file format.",
	maxFileSizeReachedDescription: "File size exceeds the maximum limit of {{maxFileSize}}MB.",
	minFileSizeNotReachedDescription: "File size is below the minimum limit of {{minFileSize}}B.",
	missingBaseColumnsDescription: "Missing base column(s).",
	maxRowsReachedDescription: "Row limit exceeded.",
	errorsFoundText: "Errors found while parsing:",
	uploadNoteText: "*Please note: For column headers with spaces/special characters, enclose the phrases in double quotes, e.g., “Experience (Years)”.",
	invalidFileDetailsBannerText: "Invalid file details, please rectify and try again."
};
var deletedColumnFilterErrorText = "The selected column filter has deleted column(s), please try again.";
var id = "'{{id}}'";
var respondentCount = "{{respondentsCount}}";
var dateRangePlaceholderText = "Select date";
var multiSelectTableTexts = {
	selectAllItems: "Select All {{totalItemCount}} Items in This List",
	clearAllSelection: "Clear All Selection",
	clearSelection: "Clear Selection",
	selection: "{{selectedItemsCount}} item(s) selected."
};
var saveChanges = "Save Changes";
var firstNameLabel = "First Name";
var firstNamePlaceholder = "Enter first name";
var lastNameLabel = "Last Name";
var lastNamePlaceholder = "Enter last name";
var failedToSaveChanges = "Failed to Save Changes";
var projectAlreadyArchivedErrorText = "This action is invalid as the project has already been archived.";
var inProgressTitle = "Data Processing in Progress";
var enterEmailAddressLabel = "Email Address";
var enterEmailAddressPlaceHolder = "Enter email address";
var invalidEmailAddressHelperText = "The provided email address is invalid.";
var invalidFirstNameLengthHelperText = "First name length must be between {{minFirstNameLength}} and {{maxFirstNameLength}}. It must not include any special characters.";
var invalidLastNameLengthHelperText = "Last name length must be between {{minLastNameLength}} and {{maxLastNameLength}}. It must not include any special characters.";
var saveChangesButtonText = "Save Changes";
var enTranslationCommon = {
	profileSettings: profileSettings,
	manageUsers: manageUsers,
	auditLogs: auditLogs,
	signOut: signOut,
	featureInDevelopment: featureInDevelopment,
	searchTableLoadingState: searchTableLoadingState,
	detailsLoadingState: detailsLoadingState,
	paginationIndicationText: paginationIndicationText,
	refresh: refresh,
	hyphen: hyphen,
	underscore: underscore,
	goToHome: goToHome,
	proceed: proceed,
	cancel: cancel,
	done: done,
	close: close,
	back: back,
	remove: remove,
	unassign: unassign,
	"delete": "Delete",
	download: download,
	dismiss: dismiss,
	uploadDialog: uploadDialog,
	deletedColumnFilterErrorText: deletedColumnFilterErrorText,
	id: id,
	respondentCount: respondentCount,
	dateRangePlaceholderText: dateRangePlaceholderText,
	multiSelectTableTexts: multiSelectTableTexts,
	saveChanges: saveChanges,
	firstNameLabel: firstNameLabel,
	firstNamePlaceholder: firstNamePlaceholder,
	lastNameLabel: lastNameLabel,
	lastNamePlaceholder: lastNamePlaceholder,
	failedToSaveChanges: failedToSaveChanges,
	projectAlreadyArchivedErrorText: projectAlreadyArchivedErrorText,
	inProgressTitle: inProgressTitle,
	enterEmailAddressLabel: enterEmailAddressLabel,
	enterEmailAddressPlaceHolder: enterEmailAddressPlaceHolder,
	invalidEmailAddressHelperText: invalidEmailAddressHelperText,
	invalidFirstNameLengthHelperText: invalidFirstNameLengthHelperText,
	invalidLastNameLengthHelperText: invalidLastNameLengthHelperText,
	saveChangesButtonText: saveChangesButtonText
};

var surveys = "Surveys";
var respondents = "Respondents";
var questionnaire = "Questionnaire";
var links = "Links";
var createNewSurvey = "Create New Survey";
var choiceCustomisation = "Choice Customisation";
var questionsCustomisation = "Questions Customisation";
var surveyNameHelperText = {
	invalidSurveyNameLength: "Survey name length must be between {{minLength}} to {{maxLength}} characters long.",
	invalidSurveyName: "Survey name must contain at least one alphabet and not include any special characters besides {{allowedSpecialCharacters}}.",
	surveyNameNotUnique: "Survey name is taken, try again with a different name."
};
var generateGenericSurveyLink = {
	surveyLinkCopiedToClipboard: "Survey link copied to clipboard.",
	projectAlreadyArchivedTitle: "Project Already Archived",
	projectAlreadyArchivedDescription: "Could not generate generic survey link as the project is already archived.",
	surveyNotActiveTitle: "Survey Not Active",
	surveyNotActiveDescription: "Could not generate generic survey link as the survey is not active."
};
var questionnaireList = {
	uploadRules: "Upload Rules",
	createQuestionnaire: "Create Questionnaire",
	editQuestionnaire: "Edit Questionnaire",
	createQuestionsDescription: "No questions have been added yet. Begin by creating a questionnaire.",
	errorFetchingQuestionnaire: "There was an unexpected error while trying to fetch the questionnaire, please try again.",
	backToSurveys: "Back to Survey Selection",
	ruleApplied: "Rule Applied",
	visible: "Visible",
	hidden: "Hidden"
};
var rulesDialog = {
	title: "Upload Rules",
	existingRulesButtonText: "Download Existing Rules",
	primaryButtonText: "Validate Rules",
	fileValidationTitle: "File Validation",
	fileValidationDescription: "The file validation has been successfully completed.",
	invalidFileErrorDescription: "Errors were detected while validating the rule file. Please correct these errors and upload the file again to continue."
};
var addSurvey = {
	noSurveysCreatedTitle: "No Surveys Created",
	noSurveysCreatedDescription: "There are no surveys created yet. Get started by creating a new survey.",
	createSurveyButtonText: "Create New Survey",
	addSurveyDialog: {
		title: "Create New Survey",
		description: "Please provide the survey name, this will be used as the survey’s display name. You can change this later on in the survey settings.",
		inputFieldTitle: "Survey Name",
		inputFieldPlaceholder: "Enter survey name",
		primaryButtonText: "Create Survey",
		secondaryButtonText: "Cancel",
		permanentError: "There was an unexpected error while trying to create the survey, please try again.",
		maximumSurveyCountExceededErrorText: "A new survey could not be created, as the maximum limit of 16 surveys per project has been reached.",
		projectAlreadyArchivedErrorText: "A new survey could not be created, as the project has been archived."
	},
	questionSavedSuccessfullyDescription: "Are you sure you want to reset? Once the reset is done, the data cannot be retrieved back."
};
var deleteQuestion = {
	deleteButtonText: "Delete",
	deleteQuestionTitle: "Delete Question?",
	deleteQuestionDescription: "Are you sure you want to delete the question? Once deleted, the data cannot be retrieved back.",
	deleteGroupQuestionDescription: "Are you sure you want to delete the group question? Once deleted, the data cannot be retrieved back. Please note that all the child questions will also be deleted.",
	deletedQuestionButtonText: "Delete Question",
	failedToDeleteTitle: "Failed to Delete Question",
	unexpectedErrorDescription: "There was an unexpected error while trying to delete the question, please try again.",
	surveyIsLiveDescription: "The survey is live, the questions cannot be deleted."
};
var addSurveyQuestion = {
	openEnded: {
		openEndedFieldCustomisation: "Open Ended Field Customisation",
		entry: "ENTRY {{index}}",
		code: "Code",
		hint: "Hint",
		fieldTitle: "Field Title",
		hintPlaceholder: "Enter your response here"
	},
	singleChoice: {
		choiceDisplayType: "Choice Display Type",
		selection: "Selection",
		cards: "Cards",
		radioButtons: "Radio Buttons",
		dropdown: "Dropdown",
		slider: "Slider",
		defaultSlider: "Default Slider",
		rygSlider: "RYG Slider",
		ratingScale: "Rating Scale",
		defaultScale: "Default Scale",
		scaleWithText: "Scale with Text",
		neutralScale: "Neutral Scale",
		netPromoterScore: "Net Promoter Score™",
		defaultNPS: "Default NPS",
		npsPrefilledColor: "NPS Pre-filled Color",
		npsBorderColor: "NPS Border Color",
		presets: "Presets",
		scale: "Scale",
		presetType: "Preset Type",
		choiceOptions: "Choice Options",
		choosePresetLiteral: "Choose Preset",
		showNAOption: "Show NA option",
		showSelectionInColor: "Show selection in color",
		horizontal: "Horizontal",
		vertical: "Vertical",
		cardDirection: "Card Direction",
		textAlignment: "Text Alignment",
		center: "Center",
		left: "Left",
		right: "Right",
		npsSettings: "NPS Settings",
		naOption: "NA Option",
		notApplicable: "Not Applicable",
		na: "NA",
		poor: "Poor",
		fair: "Fair",
		good: "Good",
		high: "High",
		medium: "Medium",
		low: "Low",
		stronglyDisagree: "Strongly disagree",
		disagree: "Disagree",
		somewhatDisagree: "Somewhat disagree",
		agreeNorDisagree: "Neither agree nor disagree",
		somewhatAgree: "Somewhat agree",
		agree: "Agree",
		stronglyAgree: "Strongly agree",
		extremelyDissatisfied: "Extremely dissatisfied",
		dissatisfied: "Dissatisfied",
		somewhatDissatisfied: "Somewhat dissatisfied",
		neutral: "Neutral",
		somewhatSatisfied: "Somewhat satisfied",
		satisfied: "Satisfied",
		extremelySatisfied: "Extremely satisfied",
		notAtAllWilling: "Not at all willing",
		notWilling: "Not willing",
		somewhatNotWilling: "Somewhat not willing",
		somewhatWilling: "Somewhat willing",
		willing: "Willing",
		extremelyWilling: "Extremely willing",
		notAtAllLikely: "Not at all likely",
		unlikely: "Unlikely",
		somewhatUnlikely: "Somewhat unlikely",
		somewhatLikely: "Somewhat likely",
		likely: "Likely",
		extremelyLikely: "Extremely likely",
		singleChoicePresets: {
			select: "Select",
			agreement: "Agreement",
			satisfaction: "Satisfaction",
			willingness: "Willingness",
			likelihood: "Likelihood",
			value: "Value",
			goodPoor: "Good-Poor",
			netPromoterScore: "Net Promoter Score (NPS)"
		}
	},
	multiChoice: {
		maxSelectionTitle: "Max. Selection"
	},
	grid: {
		rowsTitle: "Rows",
		columnsTitle: "Columns",
		rowCustomizationTitle: "ROW CUSTOMIZATION",
		customise: "Customise",
		customiseGrid: "Customise Grid",
		gridSizeCustomisation: "Grid Size Customisation",
		columnQuestionTitle: "COLUMN {{index}}",
		row: "Row",
		column: "Column {{index}}",
		enterRowHeaderPlaceholderText: "Enter row header",
		enterColumnHeaderPlaceholderText: "Enter column header",
		fieldConfiguration: "Field Configuration",
		indicateAllRowOptionsMandatory: "Indicate all the row options as mandatory if row attempted",
		totalGridSizeExceeded: "The total count must not exceed {{maxGridSize}}."
	},
	group: {
		noQuestionsAdded: "There are no questions added yet to this group.",
		addQuestion: "Add Question"
	},
	allowChoiceReset: "Allow the user to reset their choices",
	allowOpenEndedResponseReset: "Allow the user to reset their response",
	allowMultiLineTextEntry: "Allow multi line text entry",
	questionTypeLiteral: "Question Type",
	questions: "Questions",
	manage: "Manage",
	previewSurvey: "Preview Survey",
	noQuestionsCreated: "No Questions Created",
	noQuestionsCreatedDescription: "Get started by clicking on the ‘Add New Question’ button.",
	questionNotSelected: "Select a Question to View Details",
	questionNotSelectedDescription: "Select a question to view its details and make changes to it.",
	addNewQuestion: "Add New Question",
	selectQuestionType: "Select Question Type",
	save: "Save",
	reset: "Reset",
	clone: "Clone",
	reload: "Reload",
	basicInfo: "Basic Information",
	questionCode: "Question Code",
	question: "Question",
	questionNumber: "Question {{index}}",
	questionDescription: "Question Description",
	messageDescription: "Message Description",
	questionAttributes: "Question Attributes",
	indicateMandatory: "Indicate this question as mandatory to the respondent",
	makeQuestionVisible: "Make this question visible by default",
	indicateAllOptionsMandatory: "Indicate that all the options for this question are mandatory",
	ensureRequiredFields: "Please ensure that all the required fields are filled in before saving the question.",
	ensureMaxSelectionIsNotLessThan: "Please ensure that the max. selection is not less than {{minimumMaxSelection}}.",
	ensureMaxSelection: "Please ensure that the max. selection does not exceed the total number of options.",
	ensureQuestionCodeUnique: "Please ensure that the question code is unique.",
	ensureOptionCodeUnique: "Please ensure that the option code is unique.",
	ensureQuestionCodeAndOptionCodesNotUpdated: "Please ensure that the question code and option code(s) are not updated for a live survey.",
	ensureRatingScaleOrSliderDoesNotExceed: "Please ensure that total number of options for rating scale or slider does not exceed {{maxRatingScaleSliderOptions}}.",
	ensureMaxRadioButtonCountNotExceeded: "Please ensure that the total number of options for radio buttons does not exceed {{maxRadioButtonCount}}.",
	ensureMaxMultiChoiceOptionsCountNotExceeded: "Please ensure that the total number of options for multi choice questions does not exceed {{maxMultiChoiceOptions}}.",
	ensureNPSDoesNotExceed: "Please ensure that total number of options for NPS is {{npsOptionsCount}}.",
	ensureNPSNotSelectedInGrid: "Please ensure that NPS is not selected in a grid question.",
	ensureGridWidthNotExceeded: "Please ensure that the total grid size count does not exceed {{maxGridWidth}}.",
	unexpectedErrorDescription: "There was an unexpected error while trying to save the changes, please try again.",
	unexpectedErrorFetchDescription: "There was an unexpected error while trying to fetch the question, please try again.",
	failedToSaveTitle: "Failed to Save Changes",
	failedToFetchTitle: "Failed to Fetch Question",
	goToSurveys: "Go to Surveys",
	surveyClosedDescription: "The survey has been closed, no further modifications can be made.",
	surveyIsLiveTitle: "Survey Is Live",
	surveyIsLiveDescription: "Any changes made to the questionnaire will affect the reports.",
	projectArchivedDescription: "The project has been archived, no further modifications can be made.",
	maxQuestionsReachedDescription: "The maximum number of questions for the survey has been reached, no further questions can be added.",
	questionDeletedDescription: "The question that you're trying to access has been deleted, please reload.",
	enterQuestionCode: "Enter question code",
	enterQuestion: "Enter question",
	enterMessage: "Enter message",
	enterQuestionDescription: "Enter question description",
	enterMessageDescription: "Enter message description",
	markdownTooltip: {
		questionDescription: "This field entry only supports the following formatting options:",
		questionOptionsDescription: "Below field entries only support the following formatting options:",
		italicsDescription: "• Italics: *text*",
		strikethroughDescription: "• Strikethrough: ~~text~~",
		boldDescription: "• Bold: **text**",
		escapeMarkdown: "• Use \\ before each special character to escape markdown"
	},
	enterCode: "Enter code",
	enterTitle: "Enter title for the field",
	enterHint: "Enter hint for the field",
	enterUniqueCode: "Enter unique code.",
	enterOption: "Enter option",
	unsavedChangesTitle: "You Have Unsaved Changes",
	unsavedChangesDescription: "Are you sure you want to proceed? Once you select another question, the unsaved changes cannot be retrieved back.",
	navigateUnsavedChangesDescription: "Are you sure you want to proceed? Once you move to a different screen, the unsaved changes cannot be retrieved back.",
	proceedConfirmationDescription: "Are you sure you want to proceed?",
	questionSavedSuccessfullyDescription: "The question has been saved successfully.",
	successfulTitle: "Successful",
	resetOptionsTitle: "Reset Confirmation",
	resetOptionsButton: "Reset",
	resetOptionsDescription: "Are you sure you want to reset? Once the reset is done, the data cannot be retrieved back.",
	mandatoryQuestionTooltipText: "This question is marked mandatory by default as the parent question was marked mandatory."
};
var questionTypes = {
	openEnded: "Open Ended",
	singleSelect: "Single Select",
	multiSelect: "Multi Select",
	grid: "Grid",
	ranking: "Ranking",
	group: "Group",
	message: "Message"
};
var manageQuestions = {
	manageQuestions: "Manage Questions",
	saveChanges: "Save Changes",
	moveOutOfGroup: "Move Out of Group",
	unexpectedErrorDescription: "There was an unexpected error while trying to save the changes, please try again.",
	unsavedChangesDescription: "Are you sure you want to proceed? Once you proceed, the unsaved changes cannot be retrieved back.",
	errorMessages: {
		surveyIsLive: "This action is no longer valid since the survey is live.",
		surveyIsClosed: "This action is no longer valid since the survey has been closed.",
		projectIsArchived: "This action is no longer valid since the project has been archived.",
		outdatedQuestionList: "The questions list is outdated, please refresh the page and try again."
	}
};
var translations = {
	translationsTitleText: "Translations",
	uploadTranslationsText: "Upload Translations",
	downloadTranslationFile: "Download Translation File",
	downloadTranslationDescription: "Please download the translation file containing the language texts. You can then input the corresponding translations into this file.",
	invalidFileErrorDescription: "The uploaded translations file is invalid, please rectify and try again.",
	maximumTranslationLimitReachedDescription: "The maximum translation limit of {{translationLimit}} has been reached.",
	translationUpdateInProgressDescription: "A translation update is already in progress. Please try again later.",
	validationLoaderDescription: "Validating translation file, please wait.",
	translationUploadProcessSuccessDescription: "The translation upload process has been initiated. The data will be updated shortly.",
	unexpectedErrorDescription: "There was an unexpected error while trying to upload the translations, please try again.",
	noTranslationsAddedTitle: "No Translations Added",
	noTranslationsAddedDescription: "No translations have been added yet. Begin by uploading a CSV of translations.",
	baseLanguageText: "Base Language",
	translatedLanguageText: "Translated Language",
	inProgressDescription: "The translation data is currently being processed. Please wait for a moment, and the updated information will be displayed once the processing is complete.",
	fetchTranslationsUnexpectedError: "There was an unexpected error while trying to fetch the translations, please try again."
};
var settings = {
	projectArchivedErrorMessage: "This action is invalid as the project is archived.",
	settingsTabTitleText: "Settings",
	genricHelperText: "Input value is too small. Minimum character limit: {{minCharacterLength}}",
	rteHelperText: "Input value length not in range. Character count must be between {{minCharacterLength}} and {{maxCharacterLength}}.",
	errorBannerText: "Please ensure all mandatory fields are filled and review any error messages before resubmitting.",
	newLineDescription: "This field requires a <br/> tag to be added for a new line. Please make sure that the <br/> tag is added on every text update.",
	saveChanges: {
		saveChangesErrorDialogTitle: "Failed to Save Changes",
		saveChangesProjectAlreadyArchivedErrorText: "The project has been archived, no further modifications can be made.",
		saveChangesSurveyClosedErrorText: "This survey has been closed, no further modifications can be made."
	},
	surveyNameSettings: {
		surveyNameTitleText: "Survey Name",
		surveyNameTextboxPlaceholderText: "Enter survey name"
	},
	clientLogoSettings: {
		clientLogoTitleText: "Client Logo",
		clientLogoDescriptionText: "Allowed formats are JPEG or PNG. Please ensure that the file size is below {{maxFileSize}}MB. Dimensions must be 115px * 45px.",
		lightThemeLogoText: "Light Theme Logo",
		darkThemeLogoText: "Dark Theme Logo",
		uploadLogoButtonText: "Upload Logo",
		resetLogoButtonText: "Reset",
		helperTexts: {
			invalidFormat: "Invalid format, please try again.",
			maxFileSizeReached: "Please ensure that the file size is below {{maxFileSize}}MB.",
			minFileSizeReached: "Please ensure that the file size is above {{minFileSize}}KB."
		}
	},
	themingSettings: {
		themingTitleText: "Theming",
		surveyThemeDropdownLabelText: "Survey Theme",
		surveyThemeDropdownPlaceholderText: "Select survey theme",
		surveyThemeDropdownEnums: {
			lilacSerenade: "Lilac Serenade",
			summerSunset: "Summer Sunset",
			winterMidnight: "Winter Midnight",
			autumnHarvest: "Autumn Harvest",
			springBlossom: "Spring Blossom",
			crimsonFall: "Crimson Fall",
			arcticMonochrome: "Artic Monochrome"
		}
	},
	languagePreferencesSettings: {
		languagePreferencesTitleText: "Language Preferences",
		defaultLanguageDropdownLabelText: "Default Language",
		defaultLanguageDropdownPlaceholderText: "Select default language",
		persistentLanguageCheckboxLabelText: "Persistent Language Selection Option",
		persistentLanguageCheckboxDescriptionText: "Allow the respondent to change the language on all questions.",
		defaultLanguageCheckboxLabelText: "Display Language Selection on Survey Start",
		defaultLanguageCheckboxDescriptionText: "Display language change options within a dialog box when the respondents starts the survey."
	},
	surveyControlPreferencesSettings: {
		surveyControlPreferencesTitleText: "Survey Control Preferences",
		autoProgressLabelText: "Auto Progress",
		autoProgressDescriptionText: "Enable auto progress for single choice.",
		showProgressPercentageLabelText: "Show Progress Percentage",
		showProgressPercentageDescriptionText: "Show the percentage of survey progress to the respondent. The percentage calculation will be approximate with the application of rules.",
		donotTrackIpLabelText: "Don't Track IP",
		donotTrackIpDescriptionText: "Enabling this feature will disable the tracking of the respondent's IP address.",
		askRespondentConsentLabelText: "Ask for Respondent’s Consent",
		askRespondentConsentDescriptionText: "Enabling this feature will ask for respondent’s consent before taking the survey.",
		showRatingScaleOptionText: "Show Rating Scale Extreme Labels at the Bottom",
		showRatingScaleOptionDescriptionText: "Enabling this feature will show the rating scale labels both at the top and bottom of the extreme values.",
		resetOptionControlInQUestionnaireText: "Reset Option Control in Questionnaire",
		resetOptionControlInQUestionnaireDescriptionText: "Enabling this feature will display the reset control in the questionnaire configuration."
	},
	fontPreferencesSettings: {
		fontPreferencesTitleText: "Font Preferences",
		fontDropdownLabelText: "Font",
		fontDropdownPlaceholderText: "Select font",
		fontSizeDropdownLabelText: "Font Size",
		fontSizeDropdownPlaceholderText: "Select font size",
		fontSizeDropdwonEnum: {
			defaultScale: "Default",
			smallScale: "Small",
			largeScale: "Large"
		}
	},
	surveySubmissionCustomisationSettings: {
		surveySubmissionCustomisationTitleText: "Survey Submission Customisation",
		submitConfirmationCheckboxLabelText: "Submit Confirmation",
		submitConfirmationCheckboxDescriptionText: "Prompt respondents for confirmation before submitting their responses."
	},
	surveyRestartCustomisationSettings: {
		surveyRestartCustomisationTitleText: "Survey Restart Customisation",
		allowRestartCheckboxLabelText: "Allow Restart",
		allowRestartCheckboxDescriptionText: "Allow respondents to restart the survey."
	},
	saveDraftCustomisationSettings: {
		saveDraftCustomisationTitleText: "Save Draft Customisation",
		allowSaveDraftCheckboxLabelText: "Allow to Save Draft",
		allowSaveDraftCheckboxDescriptionText: "Allow respondents to save their completed responses and continue later."
	},
	surveyAlreadySubmittedDialogCustomisationSettings: {
		surveyAlreadySubmittedDialogCustomisationTitleText: "Survey Already Submitted Dialog Customisation"
	},
	languageSelectionDialogCustomisationSettings: {
		languageSelectionDialogCustomisationTitleText: "Language Selection Dialog Customisation"
	},
	infoDialogCustomisationSettings: {
		infoDialogCustomisationTitleText: "Info Dialog Customisation",
		infoDialogCheckboxLabelText: "Info Dialog Option"
	},
	miscellaneousMessagesSettings: {
		miscellaneousMessagesTitleText: "Miscellaneous Messages",
		genericErrorMessageTitleLabelText: "Generic Error Message Title",
		genericErrorMessageTitlePlaceholderText: "Enter generic error message title",
		genericErrorMessageDescriptionLabelText: "Generic Error Message Description",
		genericErrorMessageDescriptionPlaceholderText: "Enter generic error message description",
		surveyCloseMessageTitleLabelText: "Survey Close Message Title",
		surveyCloseMessageTitlePlaceholderText: "Enter survey close message title",
		surveyCloseMessageDescriptionLabelText: "Survey Close Message Description",
		surveyCloseMessageDescriptionPlaceholderText: "Enter survey close message description",
		singleSelectDropdownPleaseSelectOneTextTitle: "Single Select Dropdown Title",
		singleSelectDropdownPleaseSelectOneTextTitlePlaceholder: "Enter single select dropdown title",
		singleSelectDropdownChooseOptionTextTitle: "Single Select Dropdown Placeholder",
		singleSelectDropdownChooseOptionTextTitlePlaceholder: "Enter single select dropdown placeholder",
		allGridRowsNotAnsweredErrorTextTitle: "All Grid Rows Not Answered Error Text",
		allGridRowsNotAnsweredErrorTextTitlePlaceholder: "Enter all grid rows not answered error text",
		allAttemptedGridRowsNotAnsweredErrorTextTitle: "All Attempted Grid Rows Not Answered Error Text",
		allAttemptedGridRowsNotAnsweredErrorTextTitlePlaceholder: "Enter all attempted grid rows not answered error text",
		areAllRankingOptionsMandatoryTextTitle: "Rank All Options Error Text",
		areAllRankingOptionsMandatoryTextTitlePlaceholder: "Enter rank all options error text",
		allRankingOptionsMandatoryTitle: "Ranking All Options Mandatory Info Text",
		allRankingOptionsMandatoryTitlePlaceholder: "Enter ranking all options mandatory info text",
		singleSelectSliderTooltipTextTitle: "Single Select Slider Tooltip Text",
		singleSelectSliderTooltipTextTitlePlaceholder: "Enter single select slider tooltip text",
		mandatoryQuestionErrorTextTitle: "Mandatory Question Error Text",
		mandatoryQuestionErrorTextTitlePlaceholder: "Enter mandatory question error text",
		multiSelectAndRankingMaxSelectionTextTitle: "Multi Select And Ranking Max Selection Text",
		multiSelectAndRankingMaxSelectionTextTitlePlaceholder: "Enter max selection text",
		questionRequiredTextTitle: "Question Required Text",
		questionRequiredTextTitlePlaceholder: "Enter question required text"
	},
	defaultButtonTitleSettings: {
		defaultButtonTitlesTitleText: "Default Button Titles",
		startButtonTitleText: "Start Button Title",
		startButtonPlaceholderText: "Enter start button title",
		continueButtonTitleText: "Continue Button Title",
		continueButtonPlaceholderText: "Enter continue button title",
		nextPageButtonTitleText: "Next Page Button Title",
		nextPageButtonPlaceholderText: "Enter next Page button title",
		previousPageButtonTitleText: "Previous Page Button Title",
		previousPageButtonPlaceholderText: "Enter previous Page button title",
		resetButtonTitleText: "Restart Button Title",
		resetButtonPlaceholderText: "Enter restart button title",
		saveButtonTitleText: "Save Button Title",
		saveButtonPlaceholderText: "Enter save button title",
		doneButtonTitleText: "Done Button Title",
		doneButtonPlaceholderText: "Enter done button title",
		restartButtonTitleText: "Restart Button Title",
		restartButtonPlaceholderText: "Enter restart button title",
		resetAnswerButtonTitleText: "Reset Answer Button Title",
		resetAnswerButtonPlaceholderText: "Enter reset answer button title"
	},
	welcomePageCustomisationSettings: {
		welcomePageCustomisationTitleText: "Welcome Page Customisation",
		showWelcomePageCheckboxLabelText: "Show Welcome Page",
		surveyWelcomePageRteLabelText: "Survey Welcome Message",
		surveyWelcomePageRtePlaceholderText: "Enter survey welcome message"
	},
	thankYouPageCustomisationSettings: {
		thankYouPageCustomisationTitleText: "Thank You Page Customisation",
		surveyCompletedPageRteLabelText: "Survey Completed Message",
		surveyCompletedPageRtePlaceholderText: "Enter survey completed message",
		isFIThankYouPageLogoShownText: "Show Feedback Insights Thank You Logo"
	},
	closeReOpenSurveySettings: {
		failedToCloseSurvey: "Failed to Close Survey",
		failedToReOpenSurvey: "Failed to Re-Open Survey",
		surveyIsNotActiveErrorMessage: "This action is invalid as the survey is currently not active. Save the current changes, and then refresh the page to view the latest survey settings.",
		surveyIsNotClosedErrorMessage: "This action is invalid as the survey is currently not closed. Save the current changes, and then refresh the page to view the latest survey settings.",
		closeSurveyTitleText: "Close Survey",
		reOpenSurveyTitleText: "Re-Open Survey",
		closeSurveyButtonText: "Close Survey",
		closeSurveyDescriptionText: "This action is only possible for an active survey. If needed, the closed survey can be reopened later for completion.",
		reOpenSurveyDescriptionText: "This action is only possible for a closed survey. If needed, the reopened survey can be closed later.",
		reOpenSurveyText: "Re-Open Survey",
		closeSurveyDialogTitle: "Close Survey?",
		closeSurveyDialogDescription: "Are you sure you want to close the survey? It will no longer accept responses from the respondents.",
		reOpenSurveyDialogTitle: "Re-Open Survey?",
		reOpenSurveyDialogDescription: "Are you sure you want to re-open the survey? It will start to accept responses from the respondents."
	},
	dialogCustomisationCommonTexts: {
		dialogCustomisationTitleText: "Dialog Customisation",
		dialogTitleLabelText: "Title",
		dialogTitlePlaceholderText: "Enter title",
		dialogDescriptionLabelText: "Description",
		dialogDescriptionPlaceholderText: "Enter description",
		dialogPrimaryActionLabelText: "Primary Action",
		dialogPrimaryActionPlaceholderText: "Enter primary action",
		dialogSecondaryActionLabelText: "Secondary Action",
		dialogSecondaryActionPlaceholderText: "Enter secondary action",
		dialogActionLabelText: "Action",
		dialogActionPlaceholderText: "Enter action"
	}
};
var enTranslationSurveys = {
	surveys: surveys,
	respondents: respondents,
	questionnaire: questionnaire,
	links: links,
	createNewSurvey: createNewSurvey,
	choiceCustomisation: choiceCustomisation,
	questionsCustomisation: questionsCustomisation,
	surveyNameHelperText: surveyNameHelperText,
	generateGenericSurveyLink: generateGenericSurveyLink,
	questionnaireList: questionnaireList,
	rulesDialog: rulesDialog,
	addSurvey: addSurvey,
	deleteQuestion: deleteQuestion,
	addSurveyQuestion: addSurveyQuestion,
	questionTypes: questionTypes,
	manageQuestions: manageQuestions,
	translations: translations,
	settings: settings
};

var internalServerErrorTitle = "Internal Server Error";
var internalServerErrorDescription = "There was an unexpected error, please try again after some time.";
var pageNotFoundTitle = "Page Not Found";
var pageNotFoundDescription = "The requested URL was not found.";
var networkErrorTitle = "Network Error";
var networkErrorDescription = "There was a network error, please try again after some time.";
var timeOutTitle = "Request Timed Out";
var timeOutDescription = "The request has timed out, please try again after some time.";
var rteFileServiceErrorHelperText = "Something went wrong.";
var resetPasswordEmailAlreadySent = "An email had already been sent to this email address. Please wait for {{resetEmailWaitDurationInMinutes}} minutes before trying again.";
var resetPasswordLimitReached = "You have reached the maximum number of password resets allowed in a day. Please try again tomorrow.";
var enTranslationErrors = {
	internalServerErrorTitle: internalServerErrorTitle,
	internalServerErrorDescription: internalServerErrorDescription,
	pageNotFoundTitle: pageNotFoundTitle,
	pageNotFoundDescription: pageNotFoundDescription,
	networkErrorTitle: networkErrorTitle,
	networkErrorDescription: networkErrorDescription,
	timeOutTitle: timeOutTitle,
	timeOutDescription: timeOutDescription,
	rteFileServiceErrorHelperText: rteFileServiceErrorHelperText,
	resetPasswordEmailAlreadySent: resetPasswordEmailAlreadySent,
	resetPasswordLimitReached: resetPasswordLimitReached
};

const eagleEnTranslation = {
    surveyDashboard: enTranslationSurveyDashboard,
    filters: enTranslationFilters,
    manageUsers: enTranslationManageUsers,
    surveyLinkStatus: enTranslationSurveyLinkStatus,
    surveyRespondentErrors: enTranslationSurveyRespondentErrors,
    welcomePage: enTranslationWelcomePage,
    surveyStatus: enTranslationSurveyStatus,
    projects: enTranslationProjects,
    common: enTranslationCommon,
    surveys: enTranslationSurveys,
    errors: enTranslationErrors,
};

export { eagleEnTranslation };
//# sourceMappingURL=index.js.map
